import TestimonialPosts from "./TestimonialPosts";

function Testimonials() {
  let num = 0;

  return (
    <>
      {/* <!-- The slideshow/carousel --> */}
      <div id="demo" className="carousel slide" data-bs-ride="carousel">
        <TestimonialPosts index="active" />
      </div>
    </>
  );
}
export default Testimonials;
